import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { SidebarContext } from "context/SidebarContext";
import VendorRatesServices from "services/VendorRatesServices";

import { notifyError, notifySuccess } from "utils/toast";

const useVendorRatesLinkCreateSubmit = (_, onModalOpen) => {
    const {
        isDrawerOpen,
        closeDrawer,
        setIsUpdate,
    } = useContext(SidebarContext);

    const [loading, setLoading] = useState(false);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedCountryCode] = useState("+91");

    const {
        register,
        handleSubmit,
        trigger,
        setValue,
        clearErrors,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            vendor_name: "",
            contact_no: "",
            state_id: "",
            city_id:"",
        },
    });

    useEffect(() => {
        register("state_id", {
            required: "State is required",
        });
         register("city_id", {
    required: "City is required",
  });
    }, [register]);

    // const handleStateChange = (stateId) => {
    //     setSelectedState(stateId);
    //     setValue("state_id", stateId);
    //     clearErrors("state_id");
    // };

const handleStateChange = (stateId) => {
  setSelectedState(stateId);

  setValue("state_id", stateId);

  clearErrors("state_id");

  // Clear city
  setSelectedCity(null);
  setValue("city_id", "");
  clearErrors("city_id");
};
const handleCityChange = (cityId) => {
  setSelectedCity(cityId);

  setValue("city_id", cityId, {
    shouldValidate: true,
  });

  clearErrors("city_id");
};

    const onSubmit = async (data) => {
        setLoading(true);

        try {
            const payload = {
                vendor_name: data.vendor_name.trim(),
                // state_id: Number(data.state_id),
                state_id: Number(selectedState),
city_id: Number(selectedCity),
                phone_number: Number(data.contact_no),
            };

            const res = await VendorRatesServices.createVendorRatesLink(payload);

            notifySuccess(
                res?.data?.message ||
                res?.message ||
                "Vendor Rate Link created successfully."
            );

            setIsUpdate(true);

            reset({
                vendor_name: "",
                contact_no: "",
                state_id: "",
                city_id: "",
            });

            setSelectedState(null);
            setSelectedCity(null);

            closeDrawer();

            if (typeof onModalOpen === "function") {
                onModalOpen();
            }
        } catch (err) {
            notifyError(
                err?.response?.data?.message ||
                err?.message ||
                "Something went wrong."
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isDrawerOpen) {
            reset({
                vendor_name: "",
                contact_no: "",
                state_id: "",
                 city_id: "",
            });

            setSelectedState(null);
            setSelectedCity(null);
            clearErrors();
        }
    }, [isDrawerOpen, reset, clearErrors]);

    // return {
    //     trigger,
    //     register,
    //     handleSubmit,
    //     onSubmit,
    //     errors,
    //     loading,
    //     selectedState,
    //     selectedCountryCode,
    //     handleStateChange,
    // };
return {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    loading,

    selectedState,
    selectedCity,

    selectedCountryCode,

    handleStateChange,
    handleCityChange,
};

};

export default useVendorRatesLinkCreateSubmit;